import axios from 'axios'

export default {
  data() {
    return {
      appearances: {},
      error: null,
      options: {
        loaded: false
      }
    }
  },
  mounted() {
    this.fetchAppearances()
  },
  methods: {
    async fetchAppearances() {
      axios.get(`${this.$api}/v2/appearances/leaderboard`).then((response) => {
        if (response.data) {
          this.appearances = response.data.data
        } else {
          this.error = 'Unable to receive data from the server. Please reload the page.'
        }
        this.options.loaded = true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Leaders/Listing/mixins/getAppearances.js